<div class="container-fluid">
  <div class="card border-light shadow-sm">
    <div class="row">
      <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
      </div>
      <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px">
        <h6>
          <span style="padding-right:5px"></span>
          <i class="fa fa-globe"></i>
          <h4>Fund My Account : </h4>
        </h6>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <!-- <label><strong>Account Balance</strong></label>
        <input class="form-control-plaintext" type="text" [ngModel]="dataCntrl.carrier.account_balance"
         readonly /> -->
         <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>Account Number</th>
              <th>Account Name</th>
              <th>Trading Name</th>
              <th>Registration Number</th>
              <!-- <th>Lead User</th>
              <th>Carrier Type Description</th> -->
              <th>Account Balance</th>
              <!-- <th>Account Status</th> -->
              </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{Carrier?.carrier_code}}</td>
                  <td>{{Carrier?.name}}</td>
                  <td>{{Carrier?.trading_name}}</td>
                  <td>{{Carrier?.registration_number}}</td>
                  <!-- <td>{{Carrier.link_person}}</td>
                  <td>{{Carrier.carrier_type_description}}</td> -->
                  <td class="balance">{{formatCurrency(Carrier?.account_balance * -1)}}</td>
                  <!-- <td>{{Carrier.status}}</td> -->
                </tr>
              </tbody>
  
       </table>
      </div>
    </div>
    <hr>
  <div class="col-sm-12">

    <div class="row">
    <div class="col-sm-12">
      <div class="container">
        <form>
  
          <div class="row">
            <div class="col-50 pull-left">
              <h3>Billing Address</h3>
              <label for="fname"><i class="fa fa-user"></i> Full Name</label>
              <input class="form-control input-sm" type="text" id="fname" name="firstname" [(ngModel)]="name" readonly >
              <label for="email"><i class="fa fa-envelope"></i> Email <font style="color: red; font-size: small;" >(Payment confirmation will be sent to this email address.*)</font></label>
              <input class="form-control input-sm" type="text" id="email" name="email" [(ngModel)]="email" readonly>              
              <label for="adr"><i class="fa fa-address-card-o"></i> Address</label>
              <input class="form-control input-sm" type="text" id="adr" name="address"  [(ngModel)]="physical_address_1">
              <label for="city"><i class="fa fa-institution"></i> Town</label>
              <input class="form-control input-sm" type="text" id="city" name="city"  [(ngModel)]="physical_address_town">
              <label for="zip"><i class="fa fa-qrcode" aria-hidden="true"></i> Postal Code</label>
              <input class="form-control input-sm" type="text" id="zip" name="zip" [(ngModel)]="physical_post_code">
              <!-- <div class="row">
                <div class="col-50">
                  <label for="state">Provice</label>
                  <input class="form-control input-sm" type="text" id="state" name="state" [(ngModel)]="Carrier.physical_address_3">
                </div>
                <div class="col-50">
                  
                </div>
              </div> -->
              
            </div>
  
            <div class="col-50">
              <h3>CrossEasy  Payment</h3>
              <label >Accepted Payment Methods</label>
              <div class="icon-container">
                <i><img width="55%" src="../../assets/paygate/Asset-12-1.svg"></i>
                <i><img width="8%"  src="../../assets/paygate/secureEFT.svg"></i>
                <i><img width="15%" src="../../assets/paygate/snapscan.png"></i>
                <i><img width="15%" src="../../assets/paygate/zapper.svg"></i>
                
              </div>
                <label for="amount"><i class="fa fa-money"></i> Enter Amount<a class="red-asterik"> *</a></label>  
                <input class="form-control input-sm" type="text" name="amount" id="amount" [(ngModel)]="amountDisplay" onfocus="this.placeholder=''" onblur="this.placeholder='R 0,00'" (blur)="formatCurrency_TaxableValue($event)" placeholder="R 0,00" (keypress)="isNumberKey($event)" required>
                <hr/>
                <button class="btn btn-md m-clr pull-right hd-btn"  (click)="InitiatePayment()"><i class="fa fa-credit-card " ></i> Complete Payment</button>
              <button class="btn btn-md m-clr pull-right hd-btn"  (click)="Goback()"><i class="fa fa-ban" ></i> Cancel</button>
              </div>
  
          </div>
          
          <!-- <input type="submit" value="Continue to checkout" class="btn"> -->
        </form>
      </div>
    </div>
    </div>  

    <div class="col-md-6">

  <hr />
 

    <form [formGroup]="checkoutForm" name="checkoutForm" id="checkoutForm" (ngSubmit)="onSubmit(checkoutForm, $event)" method="post" [action]="payGateUrl" >
      <input type="hidden" formControlName = "PAY_REQUEST_ID"  name="PAY_REQUEST_ID" [(ngModel)]="payReqId">
      <input type="hidden" formControlName = "CHECKSUM" name="CHECKSUM" [(ngModel)]="checkSum">
      <button style="display: none;" name="checkoutFormBtn" id="checkoutFormBtn"  class="button" type="submit">Purchase</button>
    </form>
  </div>
   

    <!-- </div>
    <div class="col-12" *ngIf="dataCntrl.status != 2 && !isApproval">
      <button class="btn btn-md m-clr pull-right hd-btn mt-2 ml-2"  (click)="backToTab()" title="Back"  style="float: left !important;">Back</button>
      <ng-container *ngIf="isProcess">
        <button class="btn btn-md m-clr pull-right hd-btn mt-2"  (click)="cancelApplication()" title="Cancel"  style="float: right !important;">Cancel</button>
        <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="saveTable()" title="Save & Continueto step 4"  style="float: right !important;" >Save & Continue</button>
      </ng-container>
    </div>
    <div *ngIf="isApproval" class="col-12">
      <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="saveTable()" title="Update Time-Table"  style="float: right !important;" >Update Time-Table</button>
      
    </div> -->
  </div>
</div>

